<button
  class="viz-toolbar-button"
  [class.disabled]="disabled"
  [class.open]="isOpen"
  [disabled]="disabled"
  aria-label="Axis Fit Type"
  [matMenuTriggerFor]="axisFitMenu"
  (menuOpened)="isOpen = true"
  (menuClosed)="isOpen = false"
>
  <capra-icon class="fit-to-width-icon" icon="icon-control-axis-fit-to-width" [class.analyst-studio]="isAnalystStudio"></capra-icon>
  <capra-icon [icon]="isAnalystStudio ? 'icon-chevron-mini' : 'icon-caret-mini'" class="menu-icon"></capra-icon>
</button>
<mat-menu #axisFitMenu="matMenu" class="select-menu axis-fit-menu">
  <ng-template matMenuContent>
    <button
      mat-menu-item
      *ngFor="let item of fitTypeItems; trackBy: trackByValue"
      [class.selected]="selected === item"
      (click)="setFitType(item)"
    >
      <capra-icon icon="icon-dot-indicator" *ngIf="selected === item"></capra-icon>
      {{ item.label }}
    </button>
  </ng-template>
</mat-menu>
